import { getLanguageMatch } from 'js/lib/language';

import type { CourseLanguages } from 'bundles/common/queries/useGetCourseLanguages';
import { useGetCourseLanguages } from 'bundles/common/queries/useGetCourseLanguages';
import { getAvailableLocalesForUser } from 'bundles/common/utils/localeUtils';

export type Language = {
  key: string;
  label: string;
  isOriginal: boolean;
};
const useCourseLanguageQuery = (
  courseId?: string
): { loading: boolean; languages: Language[]; courseLanguages: CourseLanguages } => {
  const languages = getAvailableLocalesForUser();
  const {
    loading: isCourseLanguageLoading,
    originalLanguage,
    autoTranslations,
    humanTranslations,
    subtitles,
  } = useGetCourseLanguages(courseId);
  const hasCourseLanguage = !!courseId && !!originalLanguage && !isCourseLanguageLoading;

  return {
    loading: isCourseLanguageLoading,
    languages: languages.map((language) => ({
      ...language,
      // This properties depend on how the translation level of the course is
      isOriginal: hasCourseLanguage && !!getLanguageMatch(language.key, originalLanguage),
    })),
    courseLanguages: {
      originalLanguage,
      autoTranslations,
      humanTranslations,
      subtitles,
    },
  };
};

export { useCourseLanguageQuery };
